import * as React from "react";
import IProps from "./IProps";
import "../../../../../../assets/sass/widgets/reviewAndPay.scss";
// import checkIcon from "../../../../../..sicon-checkmark.svg";
import ShowMoreDetails from "./component/showMore";
import {imagePathurl} from "../../../../../utils/utils";

interface IState {
    formID: any;
}

/**
 * @class ReviewCard
 * @description This class will basically be used to show more details page
 * and will only handle the object painting before the show more object comes
 * NOTE:
 * 1. This function will be used to render the page in
 * With show more data by constructing the form from the incoming data
 * via API call
 * 2. Its will be painting the data till more details and post it
 * will navigate it to show more component
 * @category Widgets
 */
class ReviewCard extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            formID: "",
        };
        this.editReviewAndPay = this.editReviewAndPay.bind(this);
    }

    /**
     *
     * @param e
     * @function editReviewAndPay
     * @description navigate to edit page
     * @ignore
     */
    editReviewAndPay(cardindex) {
        const element: HTMLElement = document.getElementsByClassName("nav-menu-item")[cardindex] as HTMLElement;
        element && element.click();
    }

    render() {
        //image CDN_PATH
        const { titleinfo, content, tabIndex } = this.props;
        const getimagePath = imagePathurl();
        const SHOW_MORE = "Show more details";
        let canGenerateReport = false;
        let emailMessageContent = "";
        emailMessageContent = content && content.emailMessage ? content.emailMessage : emailMessageContent;
        canGenerateReport = content && content.canGenerateReport ? content.canGenerateReport : false;
        let displayIcon = null;
        if (canGenerateReport) {
            displayIcon = <img className="check-icon" src={`${getimagePath}icon-checkmark.svg`} alt="search" />;
        }
        const updatedHtml = Object.keys(content).map((items, index) => {
            const isItemisCanGenReport = items === "canGenerateReport";
            const isItemisMessage = items === "emailMessage";
            const isItemisEmailId = items === "Email Address";
            const applyStyleToMsg = canGenerateReport ? "success-message" : "error-message";
            const applyStyleToicon = canGenerateReport ? "check" : "error-icon";

            if (isItemisCanGenReport || isItemisMessage) {
                return <div key={`review-${index}`}></div>;
            }
            // condition to check if it has show more  button and navigating the obj to show more Obj
            if (items === SHOW_MORE) {
                return (
                    <ShowMoreDetails
                        key={`review-${index}`}
                        title={items}
                        showMoreObj={content[items]}
                        tabIndex={tabIndex}
                    />
                );
            }
            let datanode = null;
            if (Array.isArray(content[items])) {
                datanode = (
                    <span className="gaf-description-value column">
                        {content[items].map((item, index) => (
                            <span key={`${items}-${index}`} className="display-block">
                                {item}
                            </span>
                        ))}
                    </span>
                );
            } else {
                datanode = content[items] && (
                    <span className="gaf-description-value column">
                        {content[items]}
                        {isItemisEmailId && emailMessageContent && (
                            <span className={`email-message ${applyStyleToMsg}`}>
                                <span className={`${applyStyleToicon}`}>{displayIcon}</span>
                                {emailMessageContent}
                            </span>
                        )}
                    </span>
                );
            }
            return (
                <div key={`review-${index}`} className="gaf-key-value-container row">
                    {content[items] && <span className="gaf-description-key column"> {items}</span>}
                    {datanode}
                </div>
            );
        });

        /**
         * @return
         * @description :It will be used to paint most of the object in the review and pay
         * and it will also add some controls like edit
         * @ignore
         */
        return (
            <div className="section-container commonFormTemplate formContainer gaf-review-container-holder ">
                <div className="gaf-summary-title">{titleinfo}</div>
                {updatedHtml}
            </div>
        );
    }
}

export default ReviewCard;
